import { createReducer, on } from '@ngrx/store';
import { VorlageListResource } from './vorlage.model';
import { createEmptyStateResource, createStateResource, StateResource } from '@schir-int-client/ngrx-helpers';
import { loadVorlagenAction, loadVorlagenSuccessAction } from './vorlage.actions';

export interface VorlageState {
	vorlagen: StateResource<VorlageListResource>;
}

export const initialState: VorlageState = {
	vorlagen: createEmptyStateResource(),
};

export const vorlageReducer = createReducer(
	initialState,
	on(loadVorlagenAction, (state: VorlageState): VorlageState => ({
		...state,
		vorlagen: createEmptyStateResource(true),
	})),
	on(loadVorlagenSuccessAction, (state: VorlageState, { vorlagen }): VorlageState => ({
		...state,
		vorlagen: createStateResource(vorlagen),
	}))
);
